import { useCachedSearchResults } from "./useCachedSearchResults.js";
import { fetchJsonArray } from "./stopSearchResource.js";
export function useMapSearchResults(key, t0) {
  const ready = t0 === undefined ? true : t0;
  return useCachedSearchResults(key, fetchJsonArray, ready);
}